import styled from 'styled-components';

import { MAIN_MENU_HEIGHT } from '../../ui/settings';
import { rems, getRatio } from '../../ui/helpers';

const Basic = styled.header`
  align-items: center;
  display: flex;
  height: ${rems(MAIN_MENU_HEIGHT)};
  width: 100%;
  z-index: 1080;

  a {
    align-items: center;
    display: flex;
    height: 100%;
  }

  .svg {
    ${getRatio(178, 32, 178).styled};
  }
`;

export default Basic;
